import { combineReducers } from 'redux';

import { dailypriceConstants } from '../constants';

interface StatisticState {
  statistics: any[];
  when: string;
  updatedAt: string;
  realtime: boolean;
  loading: boolean;
}

const statistics = (state: Partial<StatisticState> = {}, action) => {
  switch (action.type) {
    case dailypriceConstants.STATISTICS_REQUEST: {
      return {
        loading: true,
        statistics: state.statistics,
        realtime: state.realtime,
      };
    }
    case dailypriceConstants.STATISTICS_SUCCESS: {
      return {
        loading: false,
        statistics: action.statistics,
        when: action.when,
        updatedAt: action.updatedAt,
        realtime: action.realtime,
      };
    }
    case dailypriceConstants.STATISTICS_FAILURE: {
      return {
        error: action.error,
      };
    }

    default: {
      return state;
    }
  }
};

const histograms = (
  state = {
    loading: false,
    histograms: undefined,
    updatedAt: undefined,
  },
  action
) => {
  switch (action.type) {
    case dailypriceConstants.HISTOGRAM_REQUEST: {
      return {
        loading: true,
        histograms: state.histograms,
      };
    }
    case dailypriceConstants.HISTOGRAM_SUCCESS: {
      return {
        histograms: action.histograms,
        updatedAt: action.updatedAt,
      };
    }
    case dailypriceConstants.HISTOGRAM_FAILURE: {
      return {
        error: action.error,
      };
    }

    default: {
      return state;
    }
  }
};

export default combineReducers({
  statistics,
  histograms,
});
